import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TabComponent from './../batch-assignment/tab-component';
import OnlinePlans from './online-plans';
import PricingStructure from './pricing-structure';
import { ALL_TABS, TAB_LABELS } from 'constants/pricing-management';
import Link from 'comps/link';
import memoize from 'memoize-one';
import styled from 'styled-components';

const Container = styled.div`
  width: inherit;
  height: inherit;
  margin: 0 auto;
`;

const TabStrip = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  padding: 0 15px;
`;

const TabLink = styled(Link)`
  position: relative;
  min-width: 140px;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
  color: #1a1f36;

  &.active {
    font-weight: 700;
    color: #4f2fbf;

    &:after {
      position: absolute;
      content: '';
      left: 0;
      bottom: -1px;
      height: 3px;
      width: 100%;
      background: #4f2fbf;
    }
  }
`;

const { ONLINE_PLANS, PRICING_STRUCTURE } = ALL_TABS || {};

const TABS = [
  {
    id: ONLINE_PLANS,
    label: TAB_LABELS[ONLINE_PLANS],
    Component: OnlinePlans,
  },
  {
    id: PRICING_STRUCTURE,
    label: TAB_LABELS[PRICING_STRUCTURE],
    Component: PricingStructure,
  },
];

const getTabs = memoize(tabs =>
  tabs.map(tab => ({
    ...tab,
    link: `/pricing-management/${tab.id}`,
  })),
);

class PricingManagement extends PureComponent {
  static defaultProps = {
    match: null,
  };

  static propTypes = {
    match: PropTypes.shape({}),
  };

  render() {
    const {
      match: {
        params: { activeTab },
      },
    } = this.props;
    const tabs = getTabs(TABS);
    const selectedTab = activeTab || tabs[0].id;

    return (
      <Container>
        <TabStrip>
          {tabs.map(({ id, label, link }) => (
            <TabLink key={id} to={link} className={id === selectedTab ? 'active' : undefined}>
              {label}
            </TabLink>
          ))}
        </TabStrip>
        <TabComponent tabs={tabs} activeTab={selectedTab} />
      </Container>
    );
  }
}

export default PricingManagement;
